import {toAccountsError} from "../../firebase/errors";
import {useState} from "react";
import {waitAtLeast} from "../../test/test-util";
import {resetPasswordWithOobCode} from "../../firebase";
import {useAuth} from "../auth/AuthContext";

type ResetPasswordSubmitFn = (oobCode: string, newPassword: string) => Promise<void>

export type UseResetPasswordReturn = {
  isLoading: boolean;
  isSubmitting: boolean;
  isSuccess: boolean;
  clearSuccess: () => void;
  isError: boolean;
  clearError: () => void;
  resetPassword?: ResetPasswordSubmitFn;
}

export const useResetPassword = (minLoadingTime = 500): UseResetPasswordReturn => {
  const [isSubmitting, setSubmitting] = useState<boolean>(false);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);
  const {user, loading: loadingUser} = useAuth();

  const result : UseResetPasswordReturn = {
    isLoading: false,
    isSubmitting,
    isSuccess,
    clearSuccess: () => setIsSuccess(false),
    isError,
    clearError: () => setIsError(false),
  }

  if (loadingUser) {
    return {
      ... result,
      isLoading: true,
    }
  }
  let resetPassword = undefined;
  if (!user) {
    resetPassword = async (oobCode: string, newPassword: string) => {
      setSubmitting(true);
      return waitAtLeast(doResetPassword(oobCode, newPassword), minLoadingTime)
          .then(() =>  setIsSuccess(true))
          .catch(err => {
            setIsError(true);
            return Promise.reject(err);
          })
          .finally(() => setSubmitting(false));
    }
  }
  return {
    ... result,
    isLoading: false,
    resetPassword,
  }
};

const doResetPassword = async (oobCode: string, newPassword: string) => {
  return resetPasswordWithOobCode(oobCode, newPassword).
  then(()=>{return}).
  catch(err => Promise.reject(toAccountsError(err, "invalidUsernameOrPassword")));
};
